import { render, staticRenderFns } from "./CardsBlock.vue?vue&type=template&id=f0a67d3a&scoped=true&"
import script from "./CardsBlock.vue?vue&type=script&lang=js&"
export * from "./CardsBlock.vue?vue&type=script&lang=js&"
import style0 from "./styles/CardsBlock.scss?vue&type=style&index=0&id=f0a67d3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a67d3a",
  null
  
)

export default component.exports